import {useTranslation} from "next-i18next"
import {useRouter} from "next/router"
import React from "react"
import {ArrowLeft} from "react-bootstrap-icons"
import Typography from "../../reusable/Typography/Typography"
import {kundendienstPaths} from "./kundendienstPaths"

const KundendienstNavigation = () => {
	const router = useRouter()
	const {t} = useTranslation(["kundendienst", "common"])
	return (
		<div className={"row"}>
			<Typography
				variant="heading2"
				semanticTag="h2"
				className="col-12"
			>
				{t("customer-service-title")}
			</Typography>
			<TextByRoute router={router}
				t={t}/>
		</div>
	)
}

export default KundendienstNavigation

const TextByRoute = ({router, t}:{router:any, t:any}) => (
	<div className="d-flex align-items-center">
		{router.route !== kundendienstPaths.kundendienst &&
		<div className={"mt-2 me-2 pointer"}
			onClick={() => {
				router.back()
			}}
		>
			<ArrowLeft height={18}
				width={18}/>
		</div>
		}
		{/* Add missing navigation text IMPORTANT!!!!! */}
		{router.route === kundendienstPaths.kundendienst ? <Typography
			variant="bodyLg"
			semanticTag="p"
			className="mt-4 mb-3 col-12"
		>
			{t("intro-subtitle")}
		</Typography> :
			router.asPath === `/serviceclient/${kundendienstPaths.noCustomer}` ? <Typography
				variant="bodyLg"
				semanticTag="p"
				className="mt-4 mb-3 col-12"
			>
				{t("no-customer-header-text")}
			</Typography> :
				router.asPath === `/serviceclient/${kundendienstPaths.customer}` ? <Typography
					variant="bodyLg"
					semanticTag="p"
					className="mt-4 mb-3 col-12"
				>
					{t("customer-header-text")}
				</Typography> :
					router.asPath === `/serviceclient/customer/${kundendienstPaths.bikeIssue}` ? <Typography
						variant="bodyLg"
						semanticTag="p"
						className="mt-4 mb-3 col-12"
					>
						{t("bike-date-question")}
					</Typography> : null
		}
	</div>
)
